export const TRANSIENT_TOKEN = 'transient_token';

// `thirdPartyName` slug on the Zoho OAuth redirect URI (ZohoOAuth2Client in service-authenticator).
export const ZOHO_THIRD_PARTY_SLUG = 'zoho';

export const SALESFORCE_PENDING_INTEGRATION_ID_KEY = 'salesforce_pending_integration_id';
